module.exports = __webpack_public_path__ + "static/img/ios.6b9c89a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info/ios.png
// module id = RHrX
// module chunks = 1